module.exports = __webpack_public_path__ + "media/images/docflix-logo-1178468e52f1835508a50c3d61a70f64.png";